// Client-side analytics seam. No provider wired yet (Ahoy removed, Amplitude TBD);
// calls are no-ops until window.analytics is set or this is updated.
export function trackEvent(name, properties = {}) {
  if (window.analytics && typeof window.analytics.track === "function") {
    window.analytics.track(name, properties)
  }
}
